export default __webpack_public_path__ + "static/media/coin.0766e322.png";